import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import { ClipartSelectorButtonNew } from '../menus/ClipartSelectorButtonNew';
import { ClipartSelectorButtonExpandedNew } from '../menus/ClipartSelectorButtonExpandedNew';
import appParameters from '../../components/utils/AppParameters'
import masterUniverseUtils from '../../components/utils/MasterUniverseUtils';
import properties from '../../constants/Properties';
import mouseUtils from '../../components/utils/MouseUtils';
import platformDetection from '../../components/utils/PlatformDetection';
import hoverManager from '../utils/HoverManager';
import locales from '../../locales/LocalesManager';

const ClipartSelectorListNewContent = React.createClass({
    getInitialState() {
        return {
            isOver: false,
            elements: []
        };
    },
    componentDidMount() {
        this.initElements();
    },
    componentWillReceiveProps: function(nextProps) {
        if (nextProps.clipartCategory != this.props.clipartCategory || nextProps.dataProvider != this.props.dataProvider || nextProps.isUniversesVisible != this.props.isUniversesVisible) {
            setTimeout(this.refreshView, 50);

            if (nextProps.isUniversesVisible)
                mouseUtils.setFocusSequence();
        }
    },
    initElements() {
        var elements = this.getElements(false);
        var videoElements = this.getElements(true);

        this.setState({
            elements,
            videoElements
        });
    },
    getElements() {
        var items = this.props.dataProvider ? this.props.dataProvider : masterUniverseUtils.getCurrentThemes();
        var item;
        var elements = [];
        var i;
        const listType = this.getListStyle();

        if (!items)
            return elements;

        for (i=0; i<items.length; i++) {
            item = items[i];

            if (listType == 'collapsed')
                elements.push(<ClipartSelectorButtonNew dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} index={i} item={item} key={'clipartSelector_' + i + item.name}/>);
            else
                elements.push(<ClipartSelectorButtonExpandedNew dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} index={i} item={item} key={'clipartSelector_' + i + item.name}/>);
    }

        return elements;
    },
    getButtonLabel() {
        if (this.getListStyle() == 'collapsed')
            return locales.getCaption('makeListExpanded', 'other');
        else
            return locales.getCaption('makeListCollapsed', 'other');
    },
    onMouseIn() {
        const listStyle = this.getListStyle();

        if (listStyle == 'collapsed')
            hoverManager.show(this.refs.listView, 'expandedListView', 'left');
        else
            hoverManager.show(this.refs.listView, 'collapsedListView', 'left');

        this.setState({
            isOver: true
        });
    },
    onMouseOut() {
        hoverManager.hide();

        this.setState({
            isOver: false
        });
    },
    onChangeListStyle(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const listStyle = this.getListStyle();

        if (platformDetection.isIOS()) {
            if (listStyle == 'collapsed')
                sessionStorage.setItem('listStyle', 'exapanded');
            else
                sessionStorage.setItem('listStyle', 'collapsed');
        } else {
            if (listStyle == 'collapsed')
                localStorage.setItem('listStyle', 'exapanded');
            else
                localStorage.setItem('listStyle', 'collapsed');
        }

        setTimeout(this.refreshView, 10);
    },
    getListStyle() {
        var listStyle;

        if (platformDetection.isIOS())
            listStyle = sessionStorage.getItem('listStyle');
        else
            listStyle = localStorage.getItem('listStyle');

        if (listStyle == 'collapsed')
            return 'collapsed';
        else
            return 'exapanded';
    },
    refreshView() {
        this.initElements();
        this.forceUpdate();
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.dataProvider != newProps.dataProvider || this.props.noHits != newProps.noHits  || this.state.elements != nextState.elements || this.state.isOver != nextState.isOver || this.props.clipartCategory != newProps.clipartCategory || this.props.isUniversesVisible != newProps.isUniversesVisible || this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        if (this.props.isUniversesVisible == false || this.state == undefined || this.state.elements == undefined)
            return (<div/>);

        const topPadding = 33;
        const bottomPadding = 10;
        var topOffset = this.props.topOffset > 0 ? this.props.topOffset : 0;
        var height = this.props.windowHeight - properties.CLIPART_BUTTON_HEIGHT - 2 * properties.BROWSER_BUTTON_HEIGHT;
        var top = properties.CLIPART_BUTTON_HEIGHT + 2 * properties.BROWSER_BUTTON_HEIGHT;

        if (this.props.isSearch) {
            top = properties.SEARCH_HEIGHT() + topOffset;
            height = this.props.windowHeight - top;
        }

        if (this.props.noHits) {
            var divStyle = {
                position: 'relative',
                top: top,
                width: this.props.width,
                textAlign: 'center',
                fontSize: '15px',
                marginTop: 10
            };

            return (
                <div style={divStyle}>
                    {locales.getCaption('searchNoHits', 'other')}
                </div>
            );
        }

        const listStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_COLOR,
            width: this.props.accordionWidth,
            height: height,
            top: top,
            left: 0,
            overflowX: 'hidden',
            overflowY: 'hidden'
        };

        const listType = this.getListStyle();
        var itemHeight;

        if (listType == 'collapsed')
            itemHeight = properties.UNIVERSE_BUTTON_HEIGHT;
        else {
            const scrollWidth = 15;
            const hGap = 10;
            const bottomGap = 14;
            const textHeight = 17;
            const buttonWidth = this.props.accordionWidth - 2 * hGap - scrollWidth;
            itemHeight = buttonWidth * 9 / 16 + textHeight + bottomGap;
        }

        var items = this.state.elements;
        var componentProperties = {};
        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = this.props.accordionWidth;
        componentProperties.height = height - topPadding - bottomPadding;
        componentProperties.top = topPadding;
        componentProperties.displayState = 'block';
        componentProperties.scrollHeight = items.length * itemHeight;
        componentProperties.elements = items;
        componentProperties.backgroundColor = properties.BROWSER_COLOR;

        var iconSrc;
        var ariaChecked = false;

        if (listType == 'collapsed') {
            if (this.state.isOver == true) {
                iconSrc = appParameters.RESOURCES_LOCATION() + 'assets/collapseListHover.png';
            } else {
                iconSrc = appParameters.RESOURCES_LOCATION() + 'assets/collapseList.png';
            }
        } else {
            if (this.state.isOver == true) {
                iconSrc = appParameters.RESOURCES_LOCATION() + 'assets/expandListHover.png';
            } else {
                iconSrc = appParameters.RESOURCES_LOCATION() + 'assets/expandList.png';
            }

            ariaChecked = true;
        }

        const iconButtonStyle = {
            position: 'absolute',
            top: 7,
            right: 25,
            width: 35,
            height: 35 * 26/46,
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            textAlign: 'left',
            borderStyle: 'none',
            background: 'none',
            display: 'flex'
        };

        const iconStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: 35,
            height: 35 * 26/46
        };

        var expandCollpaseButton;

        expandCollpaseButton =
            <button aria-label={this.getButtonLabel()} role='switch' aria-checked={ariaChecked} style={iconButtonStyle} ref='listView' onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onChangeListStyle} onClick={this.onChangeListStyle}>
                <img alt='' aria-hidden='true' style={iconStyle} src={iconSrc}/>
            </button>;

        return (
            <div style={listStyle}>
                {expandCollpaseButton}

                <ScrollableComponent componentProperties={componentProperties}/>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var accordionWidth = state.accordion.width;
    var clipartCategory = state.menu.clipartCategory;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    if (clipartCategory == undefined)
        clipartCategory = 0;

    return {
        accordionWidth,
        clipartCategory
    };
}

export const ClipartSelectorListNew = connect(mapStateToProps)(ClipartSelectorListNewContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/ClipartSelectorListNew.js
 **/